<template>
  <Head title="Admin - Manage Client Tasks" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center px-4">
        <div class="col-12">
          <manage-client-tasks :client="client"></manage-client-tasks>                   
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

const props = defineProps({
  client: Object,
  lockstep: Object
});

// Set window global synchronously so it's available when child component initializes
window.__LOCKSTEP__ = props.lockstep;
</script>

